import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _extends from 'babel-runtime/helpers/extends';
export var FLUSH_INDEXED_DB = 'FLUSH_INDEXED_DB';
export var LOAD_PROGRESS = 'LOAD_PROGRESS';
export var LOADING_MP_PROGRESS_LIBRARY = 'LOADING_MP_PROGRESS_LIBRARY';
export var DELAYED_PROGRESS_FETCH_COURSE_ID = 'DELAYED_PROGRESS_FETCH_COURSE_ID';
export var REMOVE_SEQUENCE_PROGRESS = 'REMOVE_SEQUENCE_PROGRESS';
export var SET_CURRENT_COURSE_PROGRESS = 'SET_CURRENT_COURSE_PROGRESS';
export var PROGRESS_MP_ERROR_RECEIVED = 'PROGRESS_MP_ERROR_RECEIVED';
export var HANDLE_PROGRESS_ADDED = 'HANDLE_PROGRESS_ADDED';
export var FETCH_LAST_SEQUENCE_ATTEMPTED = 'FETCH_LAST_SEQUENCE_ATTEMPTED';
export var LAST_SEQUENCE_ATTEMPTED = 'LAST_SEQUENCE_ATTEMPTED';

var initialProgressState = {
  loading: false,
  progress: null,
  delayedProgressFetchCourseId: null,
  loadingMPProgressLibrary: false,
  lastSequenceAttempted: {}
};

export var progressReducer = function progressReducer() {
  var progressState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialProgressState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action && action.type) {
    case LOADING_MP_PROGRESS_LIBRARY:
      return _extends({}, progressState, {
        loadingMPProgressLibrary: action.payload.loadingMPProgressLibrary
      });

    case DELAYED_PROGRESS_FETCH_COURSE_ID:
      return _extends({}, progressState, {
        delayedProgressFetchCourseId: action.payload.courseId
      });

    case LOAD_PROGRESS:
      return _extends({}, progressState, {
        loading: true,
        currentCourseProgress: null
      });

    case SET_CURRENT_COURSE_PROGRESS:
      return _extends({}, progressState, {
        loading: false,
        currentCourseProgress: action.payload.currentCourseProgress
      });

    case LAST_SEQUENCE_ATTEMPTED:
      return _extends({}, progressState, {
        lastSequenceAttempted: {
          courseId: action.payload.courseId,
          sequenceId: action.payload.sequenceId
        }
      });

    case REMOVE_SEQUENCE_PROGRESS:
      // this removes the sequence from the local data, so it is correct
      //  even before the server returns
      if (progressState.currentCourseProgress && progressState.currentCourseProgress.sequences) {
        var newProgress = JSON.parse(_JSON$stringify(progressState.currentCourseProgress));
        var seqProgressToRemoveNdx = newProgress.sequences.findIndex(function (seqProgress) {
          return seqProgress.id === action.payload.sequenceId;
        });
        if (seqProgressToRemoveNdx !== -1) {
          newProgress.sequences.splice(seqProgressToRemoveNdx, 1);
          return _extends({}, progressState, {
            currentCourseProgress: newProgress
          });
        }
      }
      return progressState;

    default:
      return progressState;
  }
};

export var progressActions = {
  setLoadingMPProgressLibrary: function setLoadingMPProgressLibrary(loadingMPProgressLibrary) {
    return {
      type: LOADING_MP_PROGRESS_LIBRARY,
      payload: { loadingMPProgressLibrary: loadingMPProgressLibrary }
    };
  },
  flushIndexedDb: function flushIndexedDb() {
    return { type: FLUSH_INDEXED_DB };
  },
  loadProgress: function loadProgress(courseId) {
    return { type: LOAD_PROGRESS, payload: { courseId: courseId } };
  },
  fetchLastSequenceAttempted: function fetchLastSequenceAttempted(courseId) {
    return { type: FETCH_LAST_SEQUENCE_ATTEMPTED, payload: { courseId: courseId } };
  },
  setLastSequenceAttempted: function setLastSequenceAttempted(courseId, sequenceId) {
    return {
      type: LAST_SEQUENCE_ATTEMPTED,
      payload: { courseId: courseId, sequenceId: sequenceId }
    };
  },
  setDelayedProgressFetchCourseId: function setDelayedProgressFetchCourseId(courseId) {
    return { type: DELAYED_PROGRESS_FETCH_COURSE_ID, payload: { courseId: courseId } };
  },
  setCurrentCourseProgress: function setCurrentCourseProgress(currentCourseProgress) {
    return {
      type: SET_CURRENT_COURSE_PROGRESS,
      payload: { currentCourseProgress: currentCourseProgress }
    };
  },
  removeSequenceProgress: function removeSequenceProgress(userId, courseId, sequenceId, sequenceVersion) {
    return {
      type: REMOVE_SEQUENCE_PROGRESS,
      payload: { userId: userId, courseId: courseId, sequenceId: sequenceId, sequenceVersion: sequenceVersion }
    };
  },
  dispatchProgressMpError: function dispatchProgressMpError(context, throwable) {
    return {
      type: PROGRESS_MP_ERROR_RECEIVED,
      payload: { context: context, throwable: throwable }
    };
  },
  setLoadingProgressMpLibrary: function setLoadingProgressMpLibrary(loading) {
    return {
      type: LOADING_MP_PROGRESS_LIBRARY,
      payload: { loadingMPProgressLibrary: loading }
    };
  },
  handleProgressAdded: function handleProgressAdded(progressAdded) {
    return {
      type: HANDLE_PROGRESS_ADDED,
      payload: { progressAdded: progressAdded }
    };
  }
};

export var progressSelectors = {
  getLoadingMPProgressLibrary: function getLoadingMPProgressLibrary(state) {
    return state.progress.loadingMPProgressLibrary;
  },
  getIsProgressLoading: function getIsProgressLoading(state) {
    return state.progress.loading;
  },
  getCurrentCourseProgress: function getCurrentCourseProgress(state) {
    return state.progress.currentCourseProgress;
  },
  getLastSequenceAttempted: function getLastSequenceAttempted(state) {
    return state.progress.lastSequenceAttempted.sequenceId;
  },
  getDelayedProgressFetchCourseId: function getDelayedProgressFetchCourseId(state) {
    return state.progress.delayedProgressFetchCourseId;
  }
};